import { render, staticRenderFns } from "./UnconfirmedMessage.vue?vue&type=template&id=425b19e9&scoped=true&"
var script = {}
import style0 from "./UnconfirmedMessage.vue?vue&type=style&index=0&id=425b19e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b19e9",
  null
  
)

export default component.exports